import { render, staticRenderFns } from "./user-bio-8.vue?vue&type=template&id=2b4594bf&scoped=true"
import script from "./user-bio-8.vue?vue&type=script&lang=js"
export * from "./user-bio-8.vue?vue&type=script&lang=js"
import style0 from "./user-bio-8.vue?vue&type=style&index=0&id=2b4594bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4594bf",
  null
  
)

export default component.exports